import ProcedureEdit from './ProcedureEdit.container';

export default ProcedureEdit;
